import React, { Component } from 'react'
import PropTypes from "prop-types";
import { connect } from 'react-redux'
// import { Container } from 'reactstrap'
import { Link } from 'react-router-dom'
import _ from 'lodash'
import { withRouter } from 'react-router'
import { actions as notifActions } from 'redux-notifications'
import {
  Row,
  Col,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter
} from 'reactstrap'
import { bindActionCreators } from 'redux'
import { getProjectById } from '../../modules/projects'
// import moment from 'moment'
import Dropzone from 'react-dropzone'

import { push } from 'react-router-redux';
import { send } from '../../modules/media'
// import APIRequest from '../../helpers/APIRequest'
// import AsideMenu from './asideMenu'
import PotentialItem from './potential'
import StructureItem from '../structures/item'
import APIRequest from '../../helpers/APIRequest'

import { getProject } from '../../modules/projects'

import DownloadIcon from 'react-icons/lib/fa/cloud-download'
import SpinnerIcon from 'react-icons/lib/fa/spinner'
import SadIcon from 'react-icons/lib/fa/frown-o'
import CheckIcon from 'react-icons/lib/fa/check'
// import PencilIcon from 'react-icons/lib/fa/pencil'
// import TrashIcon from 'react-icons/lib/fa/trash'
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap'
import DeleteIcon from 'react-icons/lib/md/delete'
import EditIcon from 'react-icons/lib/md/edit'
//import SettingsIcon from 'react-icons/lib/md/settings'


import { getFormula } from '../../helpers/lib'

import { receiveProject, deleteProject } from '../../modules/projects'

const { notifSend } = notifActions;

class Projects extends Component {

  static contextTypes = {
    joyrideProvider: PropTypes.object.isRequired,
  }

  constructor(props) {
    super(props);
    this.state = {
      modalEditName: false,
      modalPotential: false,
      modalDelete: false,
      anodePresent: true,
      idDifferent: true,
      potentialInProgress: false,
      isGlobalPotential: false,
      anode: 'Li',
      isStructureAreOk: true,
      dropdownOpen: false,
      modalDeleteProject: false,
      modalDeletePotential: false,
      generating: false
    };
    this.toggle = this.toggle.bind(this);
    this.toggleEditName = this.toggleEditName.bind(this);
    this.togglePotentialModal = this.togglePotentialModal.bind(this);
    this.toggleDeleteProjectModal = this.toggleDeleteProjectModal.bind(this);
    this.toggleDeletePotentialModal = this.toggleDeletePotentialModal.bind(this);
    this.deleteProject = this.deleteProject.bind(this);
    this.deletePotential = this.deletePotential.bind(this);
    this.generateOtherPhases = this.generateOtherPhases.bind(this);
  }

  toggle() {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen
    });
  }

  validPotentialForm() {
    const anode = this.potentialForm.newPotAnode.value;
    const strId1 = this.potentialForm.newPotStruct1.value;
    const strId2 = this.potentialForm.newPotStruct2.value;
    let str1;
    let str2;

    let anodePresent = false;
    this.props.project.structures.forEach(structure => {
      if (structure._id === strId1) {
        str1 = _.clone(structure);
      }
      if (structure._id === strId2) {
        str2 = _.clone(structure);
      }
      anodePresent = (anodePresent || ((structure._id === strId1 || structure._id === strId2) && structure.formula.match(anode)))
        ? true
        : false;
    });

    let isStructureAreOk = true;

    if (str1 && str2) {
      let re = new RegExp(` ?${anode}\\d*(\\.\\d+)? ?`, 'g');
      const str1Table = str1.formula.replace(re, '').match(/([A-Z|a-z]+)(\d*(\.\d*)?)?/g);
      const str2Table = str2.formula.replace(re, '').match(/([A-Z|a-z]+)(\d*(\.\d*)?)?/g);
      const str1map = {};
      str1Table.forEach(elm => {
        let res = elm.match(/([A-Z|a-z]+)(\d*(\.\d*)?)?/);
        str1map[res[1]] = Number(res[2]);
      });
      const str2map = {};
      str2Table.forEach(elm => {
        let res = elm.match(/([A-Z|a-z]+)(\d*(\.\d*)?)?/);
        str2map[res[1]] = Number(res[2]);
      });

      let factor;

      isStructureAreOk = str1map.length === str2map.length
        ? Object.keys(str1map).every((key) => {
          if (!factor) {
            factor = str1map[key] / str2map[key];
          }
          return str2map[key] * factor === str1map[key];
        })
        : false;
    }

    let potentialExist = false;

    this.props.project.potentials.forEach(potential => {
      let s1isPresent = false;
      let s2isPresent = false;
      let sameAnode = potential.anode === anode;
      potential.structures.forEach(structure => {
        if (structure._id === strId1) {
          s1isPresent = true;
          if (strId2 === 'auto' && structure.delithiedStructure) {
            s2isPresent = true;
          }
        }
        if (structure._id === strId2) {
          s2isPresent = true;
        }
      });
      potentialExist = potentialExist || (s1isPresent && s2isPresent && sameAnode);
    });

    this.setState({
      anodePresent,
      idDifferent: strId1 !== strId2,
      potentialExist,
      isGlobalPotential: strId2 === 'auto',
      anode,
      isStructureAreOk
    });

    return anodePresent && strId1 !== strId2 && !potentialExist && isStructureAreOk;
  }

  toggleEditName() {
    this.setState({
      modalEditName: !this.state.modalEditName
    });
  }

  togglePotentialModal() {
    this.setState({
      modalPotential: !this.state.modalPotential
    });
  }

  toggleDeleteProjectModal() {
    this.setState({
      modalDeleteProject: !this.state.modalDeleteProject
    });
  }

  toggleDeletePotentialModal(event) {
    if (event) {
      const potentialId = event.currentTarget.dataset.id;
      this.setState({
        modalDeletePotential: !this.state.modalDeletePotential,
        potentialId
      });
    } else {
      this.setState({
        modalDeletePotential: !this.state.modalDeletePotential
      });
    }
  }

  toggleDeleteStructureModal() {
    this.setState({
      modalDeleteStructure: !this.state.modalDeleteStructure
    });
  }

  componentWillMount() {
    if (this.props) {
      const getProjectById = this.props.getProjectById;
      this.interval = setInterval(function() {
        if (this.props && this.props.project) {
          getProjectById(this.props.project._id);
        }
      }.bind(this), 10000);
    }
    if ( this.context.joyrideProvider && this.context.joyrideProvider.joyride )
      this.context.joyrideProvider.joyride.next()
  }
  componentWillUnmount() {
    clearInterval(this.interval);
  }

  generateOtherPhases(e) {
    this.setState({
      generating: true
    });
    APIRequest.post(`structures/${this.newPotStruct1.value}/otherPhase`, {
      anode: this.newPotAnode.value
    })
      .then(res => {
        this.setState({
          generating: false
        });

        this.props.notifSend({
          message: (
            <div className="alert alert-success">
              <p>{res.data.length} structures generated from <b>{res.data[0].parentStructure.name}</b></p>
              <p>Generated structures:</p>
              <ul>
                {res.data.map((structure, index) => <li key={index}>{structure.name}</li>)}
              </ul>
            </div>
          ),
          dismissAfter: 5000
        });
        this.props.getProjectById(this.props.project._id);
      })
      .catch(error => {
        console.log('ALLO', error.response, error);
        this.props.notifSend({
          message: (
            <div className="alert alert-danger">
              {error.response.data.message}
            </div>
          ),
          dismissAfter: 3000
        });
        this.setState({
          generating: false
        });
      });
  }

  potentialGlobal(event) {
    event.preventDefault();
    if (!this.validPotentialForm()) {
      return false;
    }
    this.setState({potentialInProgress: true});
    const getProjectById = this.props.getProjectById;
    const projectId = this.props.project._id;
    APIRequest.post('potentials/createGlobal', {
      project: this.props.project._id,
      structure: event.target.newPotStruct1.value.trim(),
      anode: event.target.newPotAnode.value.trim()
    }).then(res => {
      this.togglePotentialModal();
    }).catch((error) => {
      console.log('Il y a eu un problème avec l\'opération fetch: ' + error.message);
      this.setState({potentialInProgress: false});
    }).then(() => {
      getProjectById(projectId);
      this.setState({potentialInProgress: false});
    });
  }

  potential(event) {
    event.preventDefault();
    if (this.potentialForm.newPotStruct2.value === 'auto') {
      return this.potentialGlobal(event);
    }
    if (!this.validPotentialForm()) {
      return false;
    }
    this.setState({potentialInProgress: true});
    const getProjectById = this.props.getProjectById;
    const projectId = this.props.project._id;
    APIRequest.post('potentials', {
      project: this.props.project._id,
      structures: [
        event.target.newPotStruct1.value.trim(), event.target.newPotStruct2.value.trim()
      ],
      anode: event.target.newPotAnode.value.trim()
    }).then(res => {
      this.togglePotentialModal();
    }).catch((error) => {
      console.log('Il y a eu un problème avec l\'opération fetch: ' + error.message);
      this.setState({potentialInProgress: false});
    }).then(() => {
      getProjectById(projectId);
      this.setState({potentialInProgress: false});
    });
  }

  editName(event) {
    event.preventDefault();
    const projectId = this.props.project._id;
    const name = event.target.inputChangeName.value.trim();
    APIRequest.put(`projects/${projectId}`, {name}).then(res => {
      console.log(res);
      this.props.receiveProject(res.data);
      this.toggleEditName();
    }).catch((error) => {
      console.log('Il y a eu un problème avec l\'opération fetch: ' + error.message);
    });
  }

  deleteProject() {
    const projectId = this.props.project._id;
    APIRequest.delete(`projects/${projectId}`).then(res => {
      this.props.push('/projects');
      this.props.deleteProject(projectId);
    }).catch((error) => {
      console.log('Il y a eu un problème avec l\'opération fetch: ' + error.message);
    });
  }

  deletePotential() {
    const projectId = this.props.project._id;
    APIRequest.delete(`potentials/${this.state.potentialId}`).then(res => {
      this.props.getProjectById(projectId);
      this.toggleDeletePotentialModal();
    }).catch((error) => {
      console.log('Il y a eu un problème avec l\'opération fetch: ' + error.message);
    });
  }

  render() {
    const {
      project = {}
    } = this.props;
    const props = this.props;
    return (<div className="flex-main">
      <main className="main">
        <ol className="breadcrumb bg-gray-600 border-bottom-0 m-0 align-items-center">
          <li className="breadcrumb-item">
            <Link to="/projects">Projects</Link>
          </li>
          <li className="breadcrumb-item active">{getFormula(project.name)}</li>

          <li className="breadcrumb-menu d-md-down-none">
            <Dropdown isOpen={this.state.dropdownOpen} toggle={this.toggle} className="bg-none">
              <DropdownToggle className="bg-none border-0 btn-transparent text-gray-200 p-1">
                <span className="icon-settings icons" style={{fontSize: '1.2rem'}}></span>
              </DropdownToggle>
              <DropdownMenu right>
                <DropdownItem onClick={this.toggleEditName}><EditIcon /> Edit project</DropdownItem>
                <DropdownItem onClick={this.toggleDeleteProjectModal}><DeleteIcon/> Delete project</DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </li>
        </ol>
        {/*}<Col className="col-auto mr-auto pl-3 pr-3 pb-3 pt-3">
        {/*}<h2 className="card-title text-white mb-1 pb-0">{getFormula(project.name)}</h2>*/}
        {/*}<span className="col text-white m-0 p-0">Created at: {moment(project.createdAt).format('L')}</span>*/}
        {/*}</Col>
            <Col className="col-auto mr-3">
            <div className="">
            <Dropdown isOpen={this.state.dropdownOpen} toggle={this.toggle} className="bg-none border-1">
          <DropdownToggle className="bg-none border-0 btn-transparent text-gray-200">
            <span className="icon-settings icons font-2xl mt-1"></span>
          </DropdownToggle>
          <DropdownMenu right>
            <DropdownItem onClick={this.toggleEditName}><EditIcon style={{float:"right"}} /> Edit project</DropdownItem>
            <DropdownItem onClick={this.toggleDeleteProjectModal}>Delete project<DeleteIcon style={{float:"right"}}/></DropdownItem>
          </DropdownMenu>
            </Dropdown>
            </div>
        </Col>*/}
        <Modal isOpen={this.state.modalEditName} toggle={this.toggleEditName}>
          <form onSubmit={this.editName.bind(this)}>
            <ModalHeader toggle={this.toggleEditName}>Choose a new name:</ModalHeader>
            <ModalBody>
              <input type="text" id="inputChangeName" className="form-control" placeholder={project.name} required="required"/>
            </ModalBody>
            <ModalFooter>
              <Button type="submit" color="primary">Edit</Button>{' '}
              <Button color="secondary" onClick={this.toggleEditName}>Cancel</Button>
            </ModalFooter>
          </form>
        </Modal>

        <div className="animated fadeIn">
          <div className="card m-0 border-0">
            <div className="card-body">
              <div className="row align-items-center mb-3">
                <div className="col col-auto mr-auto">
                  <h4 className="card-title mb-0">List of Structures</h4>
                </div>
                <div className="col col-auto">
                  <Button color="primary" href="#addStructure" onClick={(e) => {
                    e.preventDefault();
                    if (this.dropzoneRef) {
                      this.dropzoneRef.open()
                    }
                  }}>Add structures</Button>
                </div>
              </div>
              <Row>
                <div className="col col-12">
                  <div className="card text-center">
                    <form className="card-body bg-gray-100">
                      {
                          props.isSendingFile
                            ? <div className="dropzone">
                              <p className="text-warning mb-0"><SpinnerIcon className="fa-pulse" height="3em" width="3em"/>&nbsp;
                              File is dowloading...</p>
                            </div>
                            : !props.isSendingCompleted
                              ? <Dropzone ref={(node) => {
                                this.dropzoneRef = node;
                              }} data-id={project._id} className="dropzone second-step" onDrop={props.send} inputProps={{
                                'data-id' : project._id
                              }}>
                                <p className="text-gray-400 mb-0"><DownloadIcon height="2em" width="2em"/>&nbsp;
                                  Drag <b>or choose an CIF file</b> to add a structure to this project.</p>
                              </Dropzone>
                              : props.isSendingWasSucessfull
                                ? <Dropzone ref={(node) => {
                                  this.dropzoneRef = node;
                                }} data-id={project._id} className="dropzone second-step" onDrop={props.send} inputProps={{
                                  'data-id' : project._id
                                }}>
                                  <p className="text-success"><CheckIcon height="2em" width="2em"/>&nbsp;
                                  Download successfull !</p>
                                  <p className="text-gray-400 mb-0">You can add <b>another valid CIF file</b>&nbsp;
                                  to add another structure to this project.</p>
                                </Dropzone>
                                : <Dropzone ref={(node) => {
                                  this.dropzoneRef = node;
                                }} data-id={project._id} className="dropzone second-step" onDrop={props.send} inputProps={{
                                  'data-id' : project._id
                                }}>
                                  <p className="text-danger"><SadIcon height="2em" width="2em"/> {props.errors}</p>
                                  <p className="text-gray-400 mb-0">Retry by dragging&nbsp;
                                    <b>a valid CIF file</b>&nbsp;
                                  to add a structure to this project.</p>
                                </Dropzone>
                      }
                    </form>
                  </div>
                </div>
                {
                    project.structures
                      ? project.structures.sort((a, b) => {
                        return new Date(b.createdAt) - new Date(a.createdAt);
                      }).map((structure, index) => <Col key={index} className="col-sm-12 col-md-6 col-lg-6 col-xl-4 mb-3">
                        <StructureItem key={`item-${structure._id}`} structure={structure} project={project} getProjectById={this.props.getProjectById} receiveProject={this.props.receiveProject}/>
                      </Col>)
                      : null
                }

              </Row>
            </div>
          </div>
        </div>
        <div className="card m-0 border-0">
          <div className="card-body">
            <Row className="align-items-center mb-3">
              <Col className="col-auto mr-auto">
                <h4 className="card-title mb-0">Potentiels</h4>
              </Col>
              <Col className="col-auto">
                <Button color="primary" onClick={this.togglePotentialModal}>Calculate a potential</Button>
              </Col>
            </Row>
            <Row>
              <Col>
                <Modal isOpen={this.state.modalPotential} toggle={this.togglePotentialModal}>
                  <form ref={(potentialForm) => {
                    this.potentialForm = potentialForm;
                  }} onSubmit={this.potential.bind(this)}>
                    <ModalHeader toggle={this.togglePotentialModal}>Calculate a potential:</ModalHeader>
                    <ModalBody>
                      <p className="alert alert-info">Choose the two end-member compositions below
                        <a href="#addStructure" className="alert-link" onClick={(e) => {
                          e.preventDefault();
                          if (this.dropzoneRef) {
                            this.dropzoneRef.open()
                          }
                        }}> or add a new composition here</a>.</p>
                      <div className="form-group">
                        <label className="">Choose your counter-electrode:
                        </label>
                        <select ref={node => this.newPotAnode = node} className={`custom-select form-control`} required="required" id="newPotAnode" onChange={this.validPotentialForm.bind(this)}>
                          <option value="Li">Li</option>
                          <option value="Na">Na</option>
                          <option value="K">K</option>
                          <option value="Mg">Mg</option>
                          <option value="Ca">Ca</option>
                        </select>
                      </div>
                      <div className="form-group">
                        <label>A-rich composition:
                        </label>
                        <div className="input-group">
                          <select ref={node => this.newPotStruct1 = node} className={`custom-select form-control ${this.state.idDifferent
                                        ? ''
                                        : 'is-invalid'}`} required="required" id="newPotStruct1" onChange={this.validPotentialForm.bind(this)}>
                            {
                              project.structures && project.structures.map((structure, index) => <option key={`newPotStruct1-${structure._id}`} value={structure._id} disabled={!structure.isOrdered}>{structure.name}
                                {
                                  !structure.isOrdered
                                    ? '(Disordered)'
                                    : null
                                }</option>)
                            }
                          </select>
                          <div className="input-group-prepend">
                            <button type="button" className="btn" onClick={this.generateOtherPhases} disabled={this.state.generating}>
                              { this.state.generating ? <span className="fa-spin icon-refresh"/> : <span>Generate other phases</span> }
                            </button>
                          </div>
                        </div>
                        {
                          this.state.idDifferent
                            ? <div className="invalid-feedback">The two structures must be different.</div>
                            : null
                        }
                      </div>
                      <div className="form-group">
                        <label>A-poor composition:
                        </label>
                        <select className={`custom-select form-control ${this.state.idDifferent && this.state.anodePresent && !this.state.potentialExist && this.state.isStructureAreOk
                                        ? ''
                                        : 'is-invalid'}`} required="required" id="newPotStruct2" onChange={this.validPotentialForm.bind(this)}>
                          {
                            project.structures && project.structures.map((structure, index) => <option key={`newPotStruct2-${structure._id}`} value={structure._id} disabled={!structure.isOrdered}>{structure.name}
                              {
                                !structure.isOrdered
                                  ? '(Disordered)'
                                  : null
                              }</option>)
                          }
                          <option value="auto">Automatic</option>
                        </select>
                        {
                          !this.state.anodePresent
                            ? <div className="invalid-feedback">At least one structure must contains the anode.</div>
                            : null
                        }
                        {
                          !this.state.idDifferent
                            ? <div className="invalid-feedback">The two structures must be different.</div>
                            : null
                        }
                        {
                          this.state.potentialExist
                            ? <div className="invalid-feedback">This potential has already been calculated.</div>
                            : null
                        }
                        {
                          !this.state.isStructureAreOk
                            ? <div className="invalid-feedback">The two structure must have the same base.</div>
                            : null
                        }
                      </div>

                    </ModalBody>
                    <ModalFooter>
                      <Button type="submit" color="primary" disabled={this.state.potentialInProgress}>Let's go !</Button>{' '}
                      <Button color="secondary" onClick={this.togglePotentialModal}>Cancel</Button>
                    </ModalFooter>
                  </form>
                </Modal>

              </Col>
            </Row>
            {
              project.potentials && project.potentials.length
                ? <table className="table border table-hover border-gray-200">
                  <thead className="bg-gray-100 text-gray-600 thead-border-1">
                    <tr>
                      <th>Anode</th>
                      <th>Structure 1</th>
                      <th>Structure 2</th>
                      <th>Result</th>
                      <th className="pl-0"></th>
                    </tr>
                  </thead>
                  <tbody>
                    {project.potentials.map((potential, index) => <PotentialItem key={index} potential={potential} remove={this.toggleDeletePotentialModal}/> )}
                  </tbody>
                </table>
                : null
            }</div>
        </div>
      </main>
      <Modal isOpen={this.state.modalDeleteProject} toggle={this.toggleDeleteProjectModal}>
        <ModalHeader>
          Are you sure you want to delete {project.name} ?
        </ModalHeader>
        <ModalFooter>
          <Button type="submit" color="danger" onClick={this.deleteProject}>Delete</Button>{' '}
          <Button color="secondary" onClick={this.toggleDeleteProjectModal}>Cancel</Button>
        </ModalFooter>
      </Modal>
      <Modal isOpen={this.state.modalDeletePotential} toggle={this.toggleDeletePotentialModal}>
        <ModalHeader>
          Are you sure you want to delete {project.name} ?
        </ModalHeader>
        <ModalFooter>
          <Button type="submit" color="danger" onClick={this.deletePotential}>Delete</Button>{' '}
          <Button color="secondary" onClick={this.toggleDeletePotentialModal}>Cancel</Button>
        </ModalFooter>
      </Modal>
    </div>)
  }
}

const mapStateToProps = (state, ownProps) => ({
  state: state,
  ...state.media,
  projectId: ownProps.match.params.projectId,
  project: getProject(state.projects, ownProps.match.params.projectId)
})

const mapDispatchToProps = dispatch => bindActionCreators({
  getProjectById,
  send,
  receiveProject,
  deleteProject,
  notifSend,
  push
}, dispatch)

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Projects))



// WEBPACK FOOTER //
// ./src/containers/project/index.js